module.exports = __webpack_public_path__ + "static/media/team5.3f63cca4.png";